// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b4b72220","53":"11c83cf8","116":"f05c7354","191":"c3771054","198":"3f46f90e","208":"debbc453","317":"0a164bfd","551":"1000a4f4","697":"1d50a45b","842":"929a5e95","920":"ba9d8a2e"}[chunkId] + ".chunk.js";
};